import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {HeaderComponent} from './header/header.component';
import {TranslateModule} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';
import {DetailsModalComponent} from './details-modal/details-modal.component';
import {ClassificationComponent} from './classification/classification.component';
import {FormsModule} from "@angular/forms";

@NgModule({
  declarations: [HeaderComponent, DetailsModalComponent, ClassificationComponent],
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        RouterModule,
        FormsModule,
    ],
  exports: [HeaderComponent, DetailsModalComponent, ClassificationComponent]
})
export class SharedModule { }
